module.exports = __webpack_public_path__ + "static/media/home-bgi-blue-lg.7cfcc9e9.png";